import { createI18n } from 'vue-i18n';
import english from './translations/en.js';
import french from './translations/fr.js';
import spanish from './translations/es.js';

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: english,
        fr: french,
        es: spanish
    },
    warnHtmlMessage: false,
    warnHtmlInMessage: 'off'
});

export default i18n;
